import { useEffect } from "react";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";

export function DynamicFavicon() {
  const { settings } = useSiteSettings();

  useEffect(() => {
    if (settings.site_favicon) {
      // Find existing favicon link or create one
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = settings.site_favicon;
    }
  }, [settings.site_favicon]);

  // Preload header and footer logos for faster loading
  useEffect(() => {
    const logosToPreload = [settings.site_header_logo, settings.site_footer_logo].filter(Boolean);
    logosToPreload.forEach((logoUrl) => {
      if (logoUrl) {
        const existingPreload = document.querySelector(`link[rel="preload"][href="${logoUrl}"]`);
        if (!existingPreload) {
          const preload = document.createElement("link");
          preload.rel = "preload";
          preload.as = "image";
          preload.href = logoUrl;
          document.head.appendChild(preload);
        }
      }
    });
  }, [settings.site_header_logo, settings.site_footer_logo]);

  return null;
}
